var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setClass},[(_vm.title !== '')?_c('p',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.tagsArray),function(tag){return _c('v-tag',{key:tag,attrs:{"label":tag,"chip-class":_vm.chipClass}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }